export const ERROR_VPN_CONNECT = "Error establishing VPN Connection"
export const SUCCESS_VPN_CONNECT = "VPN Connection established successfully"
export const SUCCESS_LOGIN = "Login Successful"
export const NETWORK_ADD_SUCCESS = "Network configuration added successfully"
export const NETWORK_EDIT_SUCCESS = "Network configuration updated successfully"
export const NETWORK_DELETE_SUCCESS = "Network configuration deleted successfully"